import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from '@modules/shared.module';

@Component({
  selector: 'app-button-action',
  styleUrls: ['./button-action.component.css'],
  templateUrl: './button-action.component.html',
  standalone:  true,
  imports: [MatIconModule,MatButtonModule,MatMenuModule],
})
export class ButtonActionComponent {
  @Input() actions: { label: string; icon: string; handler: () => void; roles: string[] }[] = [];
  constructor() { }

  ngOnInit(): void {
  }

}
